import { SR_API_ACTION_HOUSEHOLD_APPLICATION_MARK_RENTER_REQUIREMENTS } from 'api/actionTypes';

import updateLocalApplication from 'client/actions/HouseholdApplication/updateLocalApplication';

export default async function markRenterRequirements(
  { state, apiClient },
  { applicationId, listingId },
) {
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_APPLICATION_MARK_RENTER_REQUIREMENTS,
    state: state,
    payload: {
      applicationId,
      listingId,
    },
    onSuccess() {
      updateLocalApplication(
        { state },
        { applicationId, updates: { agreeRenterRequirements: true } },
      );
    },
  });
}
